import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { createSvgIcon } from "@mui/material";
const Icon$2 = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.01 11.83 15.18 15l1.41-1.41L12.01 9l-4.59 4.59L8.84 15z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$2 = createSvgIcon(Icon$2(), "ArrowUp");
function ArrowUp({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const ArrowUp$1 = forwardRef(ArrowUp);
const Icon$1 = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m6.121 19.293 2.877-2.877V19H11v-6l-6 .007v1.994l2.584.001-2.877 2.877zM13 11l6-.007V8.999h-2.585l2.878-2.878-1.414-1.414L15 7.585V5H13z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$1 = createSvgIcon(Icon$1(), "CloseDiagonallyRight");
function CloseDiagonallyRight({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const CloseDiagonallyRight$1 = forwardRef(CloseDiagonallyRight);
const Icon = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m14.121 11.293 2.877-2.877V11H19V5l-6 .007v1.994l2.584.001-2.877 2.877zM5 19l6-.007v-1.994H8.415l2.878-2.878-1.414-1.414L7 15.585V13H5z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon = createSvgIcon(Icon(), "OpenDiagonallyRight");
function OpenDiagonallyRight({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const OpenDiagonallyRight$1 = forwardRef(OpenDiagonallyRight);
export {
  ArrowUp$1 as A,
  CloseDiagonallyRight$1 as C,
  OpenDiagonallyRight$1 as O
};
